var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitleCurl1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 293,
    viewBox: "0 0 326 293",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1238_2413",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 326,
    height: 293
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 326,
    height: 293,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1238_2413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-543.254 239.555C-206.798 -53.7656 320.52 -3.26572 142.569 175.135C125.768 189.912 85.3167 223.572 24.8061 217.815C-50.8321 210.619 -21.6307 170.046 32.6353 157.115C61.0783 150.337 246.693 138.458 285.669 230.307C324.645 322.157 217.565 351.073 96.9405 324.35C89.9 321.279 89.0631 319.537 95.0304 316.394C111.746 306.622 274.169 393.538 320.044 523.184",
    stroke: "white",
    strokeWidth: 32
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleCurl1);
export default __webpack_public_path__ + "static/media/title_curl_1.67025259ae8c06555a333f7bd26578ee.svg";
export { ForwardRef as ReactComponent };